import { createSelector } from 'reselect'
import { isEmpty } from 'lodash-es'
import { formatDuration } from '../../sharedLegacy/utils'

const getPlaybackVideos = (state) => state.webinarPlayback.stagedPlaybackVideos
const getTimeElapsed = (state) => state.webinarPlayback.currentPlayPosition
const getDuration = (state) => state.webinarPlayback.videoDuration
const getPlaybackVideoPhotoId = (state) =>
  state.webinarPlayback.selectedPlaybackPhotoId
const getLoopingPhotoIds = (state) => state.webinarPlayback.loopingPhotoIds

export const getStagedPlaybackVideos = createSelector(
  [getPlaybackVideos],
  (videos) => {
    return videos.map((video) => {
      return {
        ...video,
        object_type: isEmpty(video.live_id) ? 'photo' : 'live',
      }
    })
  }
)

export const getElapsedTime = createSelector([getTimeElapsed], (timeElapsed) =>
  formatDuration(timeElapsed)
)

export const getTimeRemaining = createSelector(
  [getTimeElapsed, getDuration],
  (timeElapsed, duration) => {
    if (!duration) {
      return '00:00'
    }

    return formatDuration(duration - timeElapsed)
  }
)

export const getSeekBarPosition = createSelector(
  [getDuration, getTimeElapsed],
  (duration, timeElapsed) => {
    if (!duration) {
      return 0
    }

    return (timeElapsed / duration) * 100
  }
)

export const getLoopingState = createSelector(
  [getPlaybackVideoPhotoId, getLoopingPhotoIds],
  (photoId, loopingPhotoIds) => {
    return loopingPhotoIds.has(photoId)
  }
)

export const getCurrentPlaybackVideo = createSelector(
  [getStagedPlaybackVideos, getPlaybackVideoPhotoId],
  (stagedVideos, photoId) => {
    return stagedVideos.find((video) => video.photo_id === photoId)
  }
)
